import { useContext, useMemo } from 'react';
import { UserContext } from '../../UserContext';

export function useHasRole(requiredRoles = []) {
    const { user } = useContext(UserContext);
    // Assume user.listaPapeis = [{ papel: { nome: 'ADMINISTRADOR' } }, ...]
    const userRoles = useMemo(() => {
        const data = JSON.parse(localStorage.getItem('userData'));
        return Array.isArray(data?.listaPapeis)
            ? data.listaPapeis.map(p => p.papel.nome)
            : [];
    }, []);

    return useMemo(
        () => requiredRoles.some(role => userRoles.includes(role)),
        [requiredRoles, userRoles]
    );
}
